import React from 'react';
import { twMerge } from 'tailwind-merge'; // 라이브러리 추가

/**
 * 재사용 가능한 심플하고 모던한 작은 버튼 컴포넌트
 * Tailwind CSS가 적용되어 있습니다.
 *
 * @param {object} props - 컴포넌트 Props
 * @param {React.ReactNode} props.children - 버튼 내부에 표시될 내용 (텍스트, 아이콘 등)
 * @param {() => void} [props.onClick] - 버튼 클릭 시 실행될 함수
 * @param {boolean} [props.disabled=false] - 버튼 비활성화 여부
 * @param {string} [props.className=''] - 추가적으로 적용할 Tailwind CSS 클래스
 * @param {string} [props.type='button'] - 버튼 타입 ('button', 'submit', 'reset')
 */
const CustomSmallButton = ({
    children,
    onClick,
    disabled = false,
    className = '',
    type = 'button'
}) => {
    const baseClasses = `
        inline-flex items-center justify-center
        px-3 py-1.5 
        text-xs
        font-bold
        rounded-md
        transition-colors duration-200 ease-in-out
        focus:outline-none focus:ring-2 focus:ring-offset-2

        /* 기본 스타일 */
        box-border
        bg-gray-700 hover:bg-gray-500
        text-white
        focus:ring-gray-500

        /* 비활성화 상태 */
        disabled:opacity-50 disabled:cursor-not-allowed
        disabled:bg-gray-400 hover:disabled:bg-gray-400
  `;

    // twMerge를 사용하여 기본 클래스와 사용자 지정 클래스를 합칩니다.
    // twMerge는 충돌하는 클래스(예: bg-blue-600과 bg-red-500) 중 
    // 사용자 지정 클래스를 남겨두고 기본 클래스를 제거합니다.
    const mergedClasses = twMerge(baseClasses, className);

    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={mergedClasses}
        >
            {children}
        </button>
    );
};

export default CustomSmallButton;